export const incomeSelector = (state) => state.cashupReducer.income;
export const branchSelector = (state) => state.cashupReducer.branch;
export const userInfoSelector = (state) => state.cashupReducer.userInfo;
export const allSelector = (state) => state?.cashupReducer?.all;
export const detailSelector = (state) => state?.cashupReducer?.detail;
